import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearch } from "./SearchProvider";
import TitleTooltip from "../helpers/TitleTooltip";
export default function SearchBar() {
    // Guarda el ingreso en input
    const [values, setValues] = useState('');

    const { results, inputSearch } = useSearch();

    const navigate = useNavigate();

    // Llama la funcion para hacer la petición al servidor
    function handleSearch(){
        /**
         * @property search.results
         * @property search.inputSearch
         */
        inputSearch(values);

        if(results){
            navigate("/contrato/clientes");
        }
    }

    return (
        <TitleTooltip title={'La búsqueda debe ser mayor a 5 caracteres'} placement={'bottom'}>
            <div className="position-relative d-inline-flex mb-2">
                <input type="text" className="form-control form-control-solid ps-10"
                       name="find"
                       placeholder="Buscar..."
                       onChange={(e) => setValues(e.target.value)}
                       onKeyDown={(e) => {
                           if (e.key === "Enter"){ // || e.code === "NumpadEnter"
                               handleSearch();
                           }
                       }}
                />
                <button className="btn p-0 position-absolute top-50 translate-middle ms-6" type="button" onClick={handleSearch} disabled={values.length < 5}>
                    <i className="ki-duotone ki-magnifier fs-3 text-gray-500">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                </button>
            </div>
        </TitleTooltip>
    );
}
